import {HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {AccountService} from "../account.service";
import {environment} from "../../../environments/environment";

export function JwtInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const account = inject(AccountService);
  if (account.login()) {
    // 只有本服务与账号服务这两个主机带 token。matrix 那版还要让开 product 主机
    // （对齐 Android RetrofitClient），本服务不调 product 接口，那一支连同
    // environment.product 一起去掉了。
    if (
      req.url.startsWith(environment.server) || req.url.startsWith(environment.account)
    ) {
      let headers = req.headers.append('Authorization', 'Bearer ' + account.user().token);

      // 当前组织（前端保有的上下文）选中了就把组织代码带上 —— service-uart 的 Modbus 点表
      // 依它判「以哪个组织的身份操作」：/visible 按它并入该组织私有、新建按它归该组织、
      // 读改删按它校验组织成员（见 ModbusConfigResource / ModbusConfigService）。
      const orgId = account.organization().id;
      if (orgId.length > 0) {
        headers = headers.append('X-Org-Id', orgId);
      }

      const newReq = req.clone({ headers });
      return next(newReq);
    }
  }

  return next(req);
}
